import type { ExtendedTimelineItem, GanttTimeLineItem } from '@bringg-frontend/gantt-timeline';
import useStore from '../../../stores/helpers/use-context';
import type { TimeWindowTranslations } from '../translations';

const useTimeWindowRange = (timeline, ganttItems: GanttTimeLineItem[], translations: TimeWindowTranslations) => {
	const store = useStore();
	const addTimeMarker = (id: number, label: string) => {
		try {
			const customTime = timeline.getCustomTime(id);
			if (!customTime) {
				timeline.addCustomTime(new Date(id), id);
			}
		} catch (e) {
			timeline.addCustomTime(new Date(id), id);
		}

		//@ts-ignore
		timeline.setCustomTimeMarker(label, id);
	};

	const showTimeWindowRange = (taskId: number | string) => {
		const task = store.tasksById.get(+taskId);
		const wayPoint = task.way_points[0];

		if (wayPoint.no_earlier_than) {
			const noEarlierThanId = new Date(wayPoint.no_earlier_than).getTime();
			addTimeMarker(noEarlierThanId, translations.noEarlierThan);
		}

		if (wayPoint.no_later_than) {
			const noLaterThanId = new Date(wayPoint.no_later_than).getTime();
			addTimeMarker(noLaterThanId, translations.noLaterThan);
		}
	};

	const getCurrentCustomTimeMarkersIds = () => {
		const ids = [];
		const components = timeline?.components;

		if (!components) {
			return ids;
		}
		components.forEach(component => {
			if (component.customTime) {
				ids.push(component.options.id);
			}
		});
		return ids;
	};

	const removeTimeWindowRange = () => {
		getCurrentCustomTimeMarkersIds().forEach(id => {
			try {
				timeline.removeCustomTime(id);
			} catch (e) {
				console.error(e);
			}
		});
	};

	const showTimeWindowRangeById = (item: ExtendedTimelineItem) => {
		removeTimeWindowRange();
		if (!item) {
			return;
		}
		showTimeWindowRange(item.id);
	};

	return { showTimeWindowRange, removeTimeWindowRange, showTimeWindowRangeById };
};

export default useTimeWindowRange;
